module.exports = __webpack_public_path__ + "img/add.aa28f611.svg";